var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"dialog",class:{
		dialog: true,
		[_vm.dialogActiveClass]: _vm.isActive,
		'd-block': _vm.isRendered,
		persistent: _vm.cantClose,
		'dialog--action-sheet': _vm.actionSheet,
		light: _vm.light,
		'without-shadow': _vm.withoutShadow,
		'align-start': _vm.alignStart,
		'full-width': _vm.fullWidth,
		'pre-active': _vm.isPreActive,
		animation: _vm.animation
	},style:(_vm.transitionStyle)},[_c('div',{staticClass:"dialog-wrapper"},[_c('div',{staticClass:"dialog-trigger",on:{"click":_vm.closeDialogGivenPersistent}}),_c('section',{class:{
				'dialog-inner center': true,
				transparent: _vm.transparent,
				full: _vm.fullDialogContent
			},style:({
				borderRadius: _vm.getBorderRadius,
				width: _vm.realWidth,
				overflow: _vm.overflowVisible ? 'visible' : 'hidden',
				..._vm.transitionContentStyle
			})},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }